export default {
  email: 'fvdb',
  site: 'aa',
  password: 'silverfox',
}